export default __webpack_public_path__ + "static/media/Contact.888d9319.png";